import Viewership from './components/Viewership.vue'

export default Viewership

// DEPRECATED_WK



// WEBPACK FOOTER //
// ./src/app/appComponents/graphs/viewership/index.js